export const INPUT_ERROR = {
  REQUIRED: "required",
  MIN: "min",
  MAX: "max",
  MIN_LENGTH: "minlength",
  MAX_LENGTH: "maxlength",
  PATTERN: "pattern"
};

export const DOCUMENT_FIELDS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  GENDER: "gender",
  DATE_OF_BIRTH: "dateOfBirth",
  PLACE_OF_BIRTH: "placeOfBirth",
  COUNTRY: "country",
  STATE: "state",
  ADDRESS: "address",
  NATIONALITY: "nationality",
  PERSONAL_CODE: "personalCode",
  DOC_TYPE: "docType",
  DOCUMENT_SUB_TYPE: "documentSubType",
  DOC_NUMBER: "docNumber",
  DATE_OF_ISSUE: "dateOfIssue",
  DATE_OF_EXPIRATION: "dateOfExpiration",
  MRZ_LINE_1: "mrzLine1",
  MRZ_LINE_2: "mrzLine2",
  MRZ_LINE_3: "mrzLine3",
  CATEGORY: "category"
};
